import { PROMOTION_TYPE, type RnbCalculatorPayload } from 'typings'
import { mapPromotionBase } from '..'
import {
  ProgressiveDiscountConditions,
  ProgressiveDiscountEffect,
  ProgressiveDiscountPromotion,
  ProgressiveDiscountRestrictions,
} from '../../../../typings'
import {
  mapBin,
  mapClusterExpressions,
  mapPaymentMethods,
  mapShippingLocation,
  mapUTM,
} from '../conditions'
import {
  mapAccumulateWithManualPrices,
  mapBudget,
  mapMaxItemsPerCart,
  mapMaxUsagePerClient,
  mapSalesChannels,
  mapSellerIds,
  mapUsage,
} from '../restrictions'

export function mapConditions(
  data: RnbCalculatorPayload
): ProgressiveDiscountConditions {
  return {
    paymentMethods: mapPaymentMethods(data),
    utm: mapUTM(data),
    cluster: mapClusterExpressions(data),
    bin: mapBin(data),
    shippingLocation: mapShippingLocation(data),
  }
}

export function mapProgressiveDiscountEffect(
  data: RnbCalculatorPayload
): ProgressiveDiscountEffect {
  return {
    trigger: {
      collections: data.collections1BuyTogether,
      skus: data.listSku1BuyTogether,
      sameItemsOnly: data.enableBuyTogetherPerSku,
    },
    benefit: data.percentualDiscountValueList.map(({ percent, quantity }) => ({
      discount: percent,
      quantity,
    })),
  }
}

export function mapRestrictions(
  data: RnbCalculatorPayload
): ProgressiveDiscountRestrictions {
  return {
    maxUsage: mapUsage(data),
    maxUsagePerClient: mapMaxUsagePerClient(data),
    maxItemsPerCart: mapMaxItemsPerCart(data),
    accumulateWithManualPrices: mapAccumulateWithManualPrices(data),
    budget: mapBudget(data),
    sellers: mapSellerIds(data),
    salesChannels: mapSalesChannels(data),
    origin: data.origin,
  }
}

export function mapProgressiveDiscount(
  data: RnbCalculatorPayload
): ProgressiveDiscountPromotion {
  return {
    ...mapPromotionBase(data),
    type: PROMOTION_TYPE.PROGRESSIVE,
    conditions: mapConditions(data),
    restrictions: mapRestrictions(data),
    progressive: mapProgressiveDiscountEffect(data),
  }
}
